import React from "react";
import styled, { keyframes, css } from "styled-components";
import { colors } from "./colors";

const ProgressContainer = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const ProgressSVG = styled.svg`
    position: absolute;
    // transform: rotate(-90deg);
`;

const ProgressCircle = styled.circle`
    fill: none;
    stroke: ${(props) => props.color || colors.primary[900]};
    stroke-width: 2;
    stroke-linecap: round;
    transition: all 0.3s ease;
    ${(props) =>
        props.$isLoading &&
        css`
            stroke-dasharray: 90;
            stroke-dashoffset: 60;
        `}
`;

const ProgressBackground = styled.circle`
    fill: none;
    stroke: #e8ebed;
    stroke-width: 2;
`;

const IconContainer = styled.div`
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Rotation animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Spinner style
const RotatingGroup = styled.g`
    transform-origin: center;
    ${(props) =>
        props.$isLoading &&
        css`
            animation: ${spin} 1s linear infinite;
        `}
`;

const CircularProgress = ({ progress, size = 32, strokeWidth = 2, color, children, onClick, isLoading }) => {
    const center = size / 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <ProgressContainer style={{ width: size, height: size }} onClick={onClick} role="button " tabIndex={0}>
            <ProgressSVG width={size} height={size} role="img">
                <ProgressBackground cx={center} cy={center} r={radius} />
                <RotatingGroup $isLoading={isLoading} data-testid="rotating-group">
                    <ProgressCircle
                        data-testid="progress-circle"
                        cx={center}
                        cy={center}
                        r={radius}
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        color={color}
                        $isLoading={isLoading}
                    />
                </RotatingGroup>
            </ProgressSVG>
            <IconContainer>{children}</IconContainer>
        </ProgressContainer>
    );
};

export default CircularProgress;
